import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { AttendanceProcedure } from "@/@types/esus/AttendanceProcedure";

type IndicatorEsfC3CitizensProceduresHistoryItemProps = {
	attendanceProcedure: AttendanceProcedure;
};

export function IndicatorEsfC3CitizensProceduresHistoryItem({
	attendanceProcedure,
}: Readonly<IndicatorEsfC3CitizensProceduresHistoryItemProps>) {
	return (
		<>
			<Row>
				<Col>
					<p>
						<span className="fw-bold text-primary">Equipe: </span>
						{attendanceProcedure.healthTeam?.name?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="fw-bold text-primary">Unidade: </span>
						{attendanceProcedure.healthUnit?.name?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<p>
						<span className="text-primary">Profissional: </span>
						{attendanceProcedure.professional?.name?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="text-primary">Categoria: </span>
						{attendanceProcedure.cbo?.description?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<p>
						<span className="text-primary">Exame/Procedimento: </span>
						{[
							attendanceProcedure.procedure?.procedureCode?.toUpperCase() ?? "",
							attendanceProcedure.procedure?.name?.toUpperCase() ?? "",
						].join(" - ") || "N/A"}
					</p>
				</Col>
				<Col></Col>
			</Row>
		</>
	);
}
